<template>
	<div>
		<div style="background:transparent;padding:0px;">
			<div v-if="this.category" class="flexcenter breadcrumbs" style="background:transparent;align-items:start;">

				<div v-for="category in this.categoryPath" :key="category?.categoryId" style="padding:0px;margin-right:5px;">

					<!-- kategori namn-->
					<div class="flexcenter link category"
						style="background:var(--grey-1);padding:5px;margin-bottom:0px;border-radius: 5px;border:1px solid var(--grey-4);"
						@click="this.showCategoryId != category.categoryId ? this.showCategoryId = category.categoryId : this.showCategoryId = null">
						<div style="font-size: 80%;">
							/{{
							category.name
							}}</div>

						<Icon v-if="category.categoryList != null"
							:fileName="this.showCategoryId == category.categoryId ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
							style="width:12px;height:12px;margin-left:10px;" />
					</div>
					<!-- lista av underkategorier -->
					<div
						v-if="category.categoryList && category.categoryList.length > 0 && this.showCategoryId == category.categoryId"
						style="position: absolute;background:var(--grey-3);padding:5px;min-width:250px;max-height:200px;overflow-y:scroll;
								filter: drop-shadow(0px 2px 10px #777777);overscroll-behavior: contain;">

						<!-- varje underkategori-->
						<div :value="childCategory" v-for="childCategory in category.categoryList" :key="childCategory.categoryId"
							@click="selectCategory(childCategory.categoryId); this.showCategoryId = null"
							style="padding:5px;margin-bottom:5px;background:var(--grey-1);" class="flexcenter link childCategoryList"
							:title="'Visa produkter i kategori: ' + childCategory.name">

							<div v-if="childCategory.categoryList" class="flexcenter childCategory" style="width:100%;">
								{{ childCategory.name }}
								<b style="flex-grow:1;">&nbsp;</b>
								<div style="width:30px;height:20px;justify-content:end;" class="flexcenter categoryArrow"
									:title="'Visa underkategorier till: ' + childCategory.name" @click.stop="selectCategory(childCategory.categoryId); this.showCategoryId =
										childCategory.categoryId">

									<Icon v-if="this.showArrow" fileName="w3_chevron_right_black" style="width:8px;height:12px;margin-right:5px;"
										:title="'Visa underkategorier till: ' + childCategory.name" />

								</div>

							</div>

							<div v-if="!childCategory.categoryList" class="flexcenter" style="width:100%;">
								{{ childCategory?.name }}
								<b style="flex-grow:1;">&nbsp;</b>
								<div class="badge">
									{{ childCategory?.productList?.length }}
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>


import categoryHelper from '@/helper/category-helper';

export default {
	name: "SelectCategoryBR",
	components: {},
	mixins: [],
	props:{
		categoryModel:Object,
		category:Object,
		showArrow:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			//category: null,
			selectedCategoryInList: null,
			showCategoryId: null,
		};
	},
	computed: {

		



		categoryList() {

			//onst baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryList) {
				return this.categoryModel.categoryList
			}

			return null;
		},

		categoryTree() {

			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (this.categoryModel && this.categoryModel.categoryTree) {
				return this.categoryModel.categoryTree
			}

			return null;
		},

		categoryPath() {

			return categoryHelper.getCategoryPath(this.categoryTree, this.category);

			

		},


	},

	methods: {

		setCategory(category){
			this.$emit("categorySelected", category)
		},
	
		selectCategory(categoryId) {
		

			if (categoryId == 3) {
				this.setCategory(null);
				return;
			}

			const category = categoryHelper.findInCategoryTree(categoryId, this.categoryTree);

			if (category) {
				this.setCategory(category);
			}

			console.log('FP: category:', category);

		},

	
	




	},


};
</script>

<style scoped>
div.categoryArrow img.link {
	opacity: 0.2;
}

div.categoryArrow:hover img.link {
	opacity: 0.9;
}

div.breadcrumbs div.childCategoryList div.badge {
	background: var(--grey-4);
	color: var(--grey-dark-2);
}

</style>